export const COMPANY_LOGO_SIZE = 40
export const COMPANY_BANNER_SIZE = 80
